import React from 'react';
import { Box, Typography } from '@mui/material';
import { Inventory as InventoryIcon } from '@mui/icons-material';

import { degrade, ombreMarque } from '../../theme/jetons';

/**
 * LE BLOC D'IDENTITÉ — pastille et nom, sur UNE ligne. Écrit une fois, pour
 * les trois surfaces qui portent la marque.
 *
 * 🔴 IL ÉTAIT ÉCRIT DEUX FOIS, ET LES DEUX ÉCRITURES DIVERGEAIENT. La `Sidebar`
 * posait une pastille de **36 px** avec `ombreMarque(12, 0.4)` ; le `Login`
 * posait un carré de **80 px** avec `ombreMarque(32, 0.4)`, empilé au-dessus du
 * nom au lieu d'être à côté. *Deux écritures d'une même identité ne restent pas
 * identiques ; elles se mettent à dire deux choses.*
 *
 * 🔴 ET LA TROISIÈME SURFACE N'EN AVAIT AUCUNE : le tunnel d'invitation —
 * l'écran où un client CRÉE SON ENTREPRISE — n'affichait ni logo, ni nom.
 * L'invité traversait trois étapes sans que rien ne lui dise où il était.
 * *La porte par laquelle on s'engage était la seule à ne pas se nommer.*
 *
 * ⚠️ UNE SEULE PROP, ET ELLE EST BORNÉE. `degradeTexte` fait couler le dégradé
 * DANS les lettres du nom (`backgroundClip: 'text'`). Réservé à la `Sidebar` :
 * elle vit à l'intérieur du produit, sur une colonne étroite où le nom est le
 * seul titre. Les deux PORTES ne le prennent pas — un prospect y voit déjà la
 * pastille, et le procédé n'a pas de variante par mode. *La marque a le droit
 * d'apparaître une fois par écran, pas trois.*
 */
const MarqueOptimStock = ({ degradeTexte = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Box
      sx={{
        width: 36,
        height: 36,
        flexShrink: 0,
        borderRadius: 2,
        background: degrade(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: ombreMarque(12, 0.4),
      }}
    >
      <InventoryIcon sx={{ color: 'common.white', fontSize: 21.6 }} />
    </Box>
    <Typography
      variant="h6"
      component="span"
      noWrap
      sx={{
        fontWeight: 700,
        ...(degradeTexte ? {
          background: degrade(),
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        } : {}),
      }}
    >
      OptimStock
    </Typography>
  </Box>
);

export default MarqueOptimStock;
